const notesFields = {
    notes:{default:"",label:"Notes",width:12,multiline:true,rows:4},
}

export default notesFields
